<template>
  <div id="app">
    <router-view v-if="!loading" />
    <TaskPanel
      v-model="taskParams.visible"
      :opendTaskId="taskParams.task_id"
      :projectId="taskParams.project_id"
      :task_list_id="taskParams.task_list_id"
      :isdeleted="taskParams.isdeleted"
    ></TaskPanel>
    <transition name="fadeMove">
      <!-- <div class="dialog-version" v-if="show">
        <div class="box">
          <img src="image/img_update@2x.png" alt="" width="64" height="64">
          <div class="title" @click="toPage">2.1.3 版本更新</div>
        </div>
        <div class="tip">更新内容如下：</div>
        <div class="content">【通知中心】增加分类</div>
        <div class="content">【任务详情】-【评论】增加@成员功能</div>
        <div class="content">【界面】 优化项目通知、通知中心、动态、日志界面</div>
        <el-button class="button" type="primary" auto @click="iSee">我知道了</el-button>
      </div> -->
      <div class="dialog-notice-view-wrap" v-if="show">
        <!-- 更新弹窗 -->
        <div class="notice-view-update-wrap" :style="{ height: dialogHeight }" v-if="isUpdateDialog">
          <img src="image/img_update.png" alt="">
          <div class="notice-view-update" ref="noticeUpdateView">
            <p class="title" v-html="dialogDetail.title"></p>
            <div class="content" v-html="dialogDetail.notification_content">

            </div>

            <div class="btn-wrap">
              <wf-button type="primary" @click="iSee">我知道了</wf-button>
            </div>
          </div>
        </div>

        <!-- 通知弹窗 -->
        <div class="notice-view-notice-wrap" v-if="!isUpdateDialog">
          <div class="notice-view-notice">
            <p class="title">{{ dialogDetail.title }}</p>
            <div class="content" v-html="dialogDetail.notification_content">

            </div>
            <div class="btn-wrap">
              <wf-button type="primary" @click="iSee">确定</wf-button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import {
  Cookie,
  Storage
} from '@/utils/utils';
import baseUrl from '@/services/baseUrl'
import bus from './bus';
import { createEditor } from '@wangeditor/editor'
// api
import noticeApi from '@/services/api/help/help.js'

export default {
  components: {
  },
  data() {
    return {
      userMsg: '',
      loading: false,
      show: false,
      time: null,
      version: '2.1.3',
      dialogHeight: '', // 更新弹窗的高度
      dialogId: '', // 弹窗Id
      dialogDetail: {} // 弹窗详情
    };
  },
  computed: {
    ...mapState('task/task', {
      taskParams: state => state.taskParams
    }),
    // 是否为更新弹窗
    isUpdateDialog() {
      return this.dialogDetail.category ? this.dialogDetail.category === 1 : false
    }
  },
  watch: {
    '$route.path': {
      handler() {
        let userInfo = Storage.get('wfUserInfo') ? Storage.get('wfUserInfo') : ''
        if(userInfo) {
          clearTimeout(this.time)
          this.time = setTimeout(() => {
            // this.show = Storage.get('showVersionDialog') !== this.version

            this.getDialogId() // 获取最近弹窗通知id
          }, 1000);
        }
      }
    }
  },
  created() {
    // console.log('------引入的配置项-----------', require('@config/projectConfig'), process.env.NODE_ENV)
  },
  async mounted() {
    this.loading = true
    let userInfo = Storage.get('wfUserInfo') ? Storage.get('wfUserInfo') : ''
    if (userInfo) {
      await this.permissionsIndex().then(res => console.log(res)).catch(err => console.log(err)) // 获取用户权限列表
      await this.getStandardComponents({ number: 999, page: 1 })
    }
    this.loading = false
    setTimeout(() => {
      this.removeEle()
    }, 500);
  },
  methods: {
    ...mapActions('permissions/permissions', ['permissionsIndex']),
    ...mapActions('customKey/customKey', ['getStandardComponents']),
    async getDialogId() {
      const res = await noticeApi.getNoticesList({ release_status: 2 })
      if (res.data.length) {
        this.dialogId = res.data[0].id

        if (Storage.get('showDialogId') !== this.dialogId) {
          // 需获取弹窗详情并显示
          this.getDialogDetailFn() // 获取弹窗详情
        } else {
          this.show = false
        }
      }
    },
    async getDialogDetailFn() {
      const res = await noticeApi.getNoticeDetail({ id: this.dialogId })
      this.dialogDetail = res
      if (res.notification_content && ~res.notification_content.indexOf('"type":')) {
        // 将编辑器格式的文本转换为html
        this.dialogDetail.notification_content = createEditor({ content: JSON.parse(res.notification_content) }).getHtml()
      } else {
        this.dialogDetail.notification_content = res.notification_content
      }
      this.show = true

      if (this.isUpdateDialog) {
        this.$nextTick(() => {
          this.dialogHeight = `${ this.$refs.noticeUpdateView.offsetHeight + 57 }px`
        })
      }

    },
    toPage() {
      this.$router.push('/helpPage?id=version-3')
    },
    iSee() {
      // Storage.set('showVersionDialog', this.version)
      Storage.set('showDialogId', this.dialogId)
      this.show = false
    },
    removeEle() {
      let ele = window.document.getElementById('ehang-loading')
      if (ele) {
        window.document.body.removeChild(ele)
      }
    },
  },
};
</script>

<style lang="scss">
.dialog-version {
  width: 409px;
  height: 383px;
  position: fixed;
  right: 32px;
  bottom: 32px;
  background-color: #fff;
  box-shadow: 0px 4px 16px 0px rgba(13,31,60,0.16);
  border-radius: 4px;
  padding: 24px;
  box-sizing: border-box;
  z-index: 1005;
  .box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .title {
      margin-top: 16px;
      font-size: 24px;
      font-weight: 500;
      cursor: pointer;
      &:hover {
        color: $color-active;
      }
    }
  }
  .tip{
    font-size: 14px;
    font-weight: 400;
    margin-top: 35px;
    color: rgba(32, 32, 32, 0.6);
  }
  .content {
    font-size: 14px;
    font-weight: 400;
    margin-top: 18px;
    display: flex;
    align-items: center;
    &::before {
      content: '';
      display: block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: rgba(32, 32, 32, 1);
      margin-right: 7px;
    }
  }
  .button {
    margin-top: 36px;
    width: 100%;
  }
}
.dialog-notice-view-wrap {
  z-index: 9999;
  position: fixed;
  right: 32px;
  bottom: 32px;
  width: 360px;
  .notice-view-update-wrap {
    width: 100%;
    position: relative;
    img {
      display: block;
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 9;
    }
  }
  .notice-view-update,
  .notice-view-notice-wrap {
    width: 100%;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 4px 16px 0px rgba(13, 31, 60, .16);
    padding-bottom: 24px;
    box-sizing: border-box;
    .title {
      width: 100%;
      height: 44px;
      padding: 0 24px;
      box-sizing: border-box;
      font-size: 24px;
      font-weight: 500;
      line-height: 44px;
      text-align: center;
    }
    .content {
      width: 100%;
      min-height: 32px;
      max-height: 500px;
      overflow-y: scroll;
      padding: 4px 24px 10px;
      box-sizing: border-box;
      margin: 16px 0;
    }
    .btn-wrap {
      width: 100%;
      display: flex;
      justify-content: center;
      .wf-button {
        width: 108px;
      }
    }
    &.notice-view-update {
      min-height: 272px;
      position: absolute;
      left: 0;
      top: 57px;
      z-index: 8;
      padding-top: 108px;
      .title {
        p {
          text-align: center;
        }
        a {
          cursor: pointer;
          &:hover {
            color: #2682FF;
          }
        }
      }
    }
    &.notice-view-notice-wrap  {
      min-height: 204px;
      margin-top: 18px;
      padding-top: 24px;
      .title {
        text-align: left;
      }
      .content {
        margin: 24px 0;
      }
      .btn-wrap {
        justify-content: flex-end;
        padding-right: 21px;
        box-sizing: border-box;
      }
    }
  }
}
// .el-table .isChangeColor {
//   color: #000;
// }
.login-link {
  text-decoration: underline;
  color: blue;
}
#app {
  height: 100vh;
  overflow: hidden;
  .fadeMove-enter-active {
    animation: slideInRight 0.5s;
  }
  .fadeMove-leave-to {
    animation: slideOutRight 0.5s;
  }
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
#wordNullId {
  color: #2682FF;
  cursor: pointer;
}
</style>
